import { Link } from 'react-router-dom';
import { Instagram, Facebook } from 'lucide-react';
import brandMark from '@/assets/landing/brandlogo-144.webp';
import brandWord from '@/assets/landing/brandmark-195.webp';

interface PublicFooterProps {
  /** Locale prefix, e.g. "de" */
  lang?: string;
  /** Target of the brand link (Landing uses the in-page anchor) */
  brandHref?: string;
}

/**
 * Gruppierter Footer für die öffentlichen (hellen) Seiten.
 * Enthält alle bisherigen rechtlichen Links, jetzt in klaren Gruppen.
 */
export const PublicFooter = ({ lang = 'de', brandHref }: PublicFooterProps) => (
  <footer className="footer">
    <div className="wrap">
      <div className="foot-top">
        <div className="foot-brand">
          {brandHref ? (
            <a className="brand" href={brandHref} aria-label="AimUp Startseite">
              <img className="brand-mark" src={brandMark} alt="" width={144} height={126} loading="lazy" decoding="async" />
              <img className="brand-word" src={brandWord} alt="AimUp" width={195} height={63} loading="lazy" decoding="async" />
            </a>
          ) : (
            <Link className="brand" to={`/${lang}`} aria-label="AimUp Startseite">
              <img className="brand-mark" src={brandMark} alt="" width={144} height={126} loading="lazy" decoding="async" />
              <img className="brand-word" src={brandWord} alt="AimUp" width={195} height={63} loading="lazy" decoding="async" />
            </Link>
          )}
          <p className="tg">Dein persönlicher Dart-Coach. Strukturiertes Training, Statistiken und die AimUp Liga, direkt im Browser.</p>
          <div className="foot-social">
            <a href="https://www.instagram.com/aimup.darts" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><Instagram /></a>
            <a href="https://www.facebook.com/share/1G4aiCxmvZ/" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><Facebook /></a>
          </div>
        </div>

        <nav className="foot-cols" aria-label="Footer">
          <div className="foot-col">
            <h2>AimUp</h2>
            <Link to={`/${lang}/ueber-uns`}>Über uns</Link>
            <Link to={`/${lang}/darts-training`}>Trainingsmodi</Link>
            <Link to={`/${lang}/kontakt`}>Kontakt</Link>
            <Link to={`/${lang}/faq`}>FAQ</Link>
          </div>
          <div className="foot-col">
            <h2>Dart Wissen</h2>
            <Link to={`/${lang}/dart-wissen`}>Dart Wissen</Link>
            <Link to={`/${lang}/dart-wissen/dart-training-anfaenger`}>Dart Training für Anfänger</Link>
            <Link to={`/${lang}/dart-wissen/dart-trainingsplan`}>Dart Trainingsplan</Link>
            <Link to={`/${lang}/dart-wissen/dart-average-verbessern`}>Dart Average verbessern</Link>
            <Link to={`/${lang}/dart-wissen/dart-scoring-verbessern`}>Scoring verbessern</Link>
            <Link to={`/${lang}/dart-wissen/dart-doppeltraining`}>Dart Doppeltraining</Link>
            <Link to={`/${lang}/dart-wissen/dart-checkout-training`}>Dart Checkout Training</Link>
            <Link to={`/${lang}/darts-training`}>Trainingsmodi im Überblick</Link>
          </div>
          <div className="foot-col">
            <h2>Rechtliches</h2>
            <Link to={`/${lang}/impressum`}>Impressum</Link>
            <Link to={`/${lang}/datenschutz`}>Datenschutz</Link>
            <Link to={`/${lang}/agb`}>AGB</Link>
            <Link to={`/${lang}/widerruf`}>Widerruf</Link>
            <Link to={`/${lang}/vertrag-widerrufen`}>Vertrag widerrufen</Link>
            <button
              type="button"
              onClick={() => window.dispatchEvent(new Event('aimup-open-cookie-settings'))}
            >
              Cookie-Einstellungen
            </button>
          </div>
        </nav>
      </div>
      <div className="foot-bottom">© {new Date().getFullYear()} AimUp. Alle Rechte vorbehalten.</div>
    </div>
  </footer>
);

export default PublicFooter;
